// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS Badge INSTEAD.
import React from 'react';
import PropTypes from 'prop-types';
import { assign } from 'lodash';
import classNames from 'classnames';
import { getColorLuma } from "../../utils/Colors";
var Badge = function Badge(props) {
  var id = props.id,
    className = props.className,
    color = props.color,
    text = props.text,
    badgeAriaLabel = props.badgeAriaLabel,
    dataTestId = props.dataTestId;
  if (text === '' || text === undefined) {
    return null;
  }
  var luma = getColorLuma(color);
  var style = assign({}, {
    color: luma < 128 ? 'white' : '#4A657F',
    backgroundColor: props.color
  }, props.style);
  var badgeClass = function badgeClass() {
    return classNames({
      badge: true,
      'badge--square': props.shape === 'square'
    }, className);
  };
  return /*#__PURE__*/React.createElement("span", {
    id: id || null,
    className: badgeClass(),
    style: style,
    "aria-label": badgeAriaLabel,
    "data-testid": dataTestId
  }, text);
};
Badge.propTypes = {
  /** badge aria label */
  badgeAriaLabel: PropTypes.string,
  /** id for reference */
  id: PropTypes.string,
  /** className for reference */
  className: PropTypes.string,
  /** content to display */
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Hex color code */
  color: PropTypes.string.isRequired,
  /** Override the inline-styles of the root element || Not Recommended */
  style: PropTypes.object,
  /** Shape of the badge */
  shape: PropTypes.oneOf(['square', 'circle']),
  /** Immutable identifier for testing */
  dataTestId: PropTypes.string
};
Badge.defaultProps = {
  badgeAriaLabel: '',
  id: '',
  className: '',
  text: '',
  color: '#E53935',
  style: {},
  shape: 'circle',
  dataTestId: ''
};
export default Badge;